export default __webpack_public_path__ + "static/media/btnSave.dd5d4e47.svg";